<template>
    <div>
        <div class="align-items-center" style="">
                <div class="container" v-if="PageExistsButEmpty" style="margin-top:50px;">
                    <div class="row align-items-center justify-content-md-center">
                        <div class="col col-12 col-md-5 text-center">
                            <!-- Column 1 content centered -->
                            <h3 style="color:darkorange;">Nothing Here (Yet)</h3>
                            <img style="width: 100%;" src="/images/emptypage.jpg" alt="Empty Page" />

                        </div>
                        <div class="col col-12 col-md-5">
                            <!-- Column 2 content centered -->
                            <div class="text-center align-middle">
                                <small>This page is currently empty.<br/></small>
                                <br/><br/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container" v-if="ShowError" style="margin-top:50px;">
                    <div class="row align-items-center justify-content-md-center">
                        <div class="col col-12 col-md-5 text-center">
                            <!-- Column 1 content centered -->
                            <h3 style="color:darkorange;">Oops!</h3>
                            <img style="width: 100%;" src="/images/dataerror.jpg" alt="Error" />

                        </div>
                        <div class="col col-12 col-md-5">
                            <!-- Column 2 content centered -->
                            <div class="text-center align-middle">

                                <small>{{LoadPageError}}</small>

                            </div>
                        </div>
                    </div>
                </div>
             
                <component  
                            :iseditmode="false"
                            v-for="(item, index) in Store.CurrentPageBlockNodes" 
                            :is="item.ComponentType"
                            v-bind:componenttype="item.ComponentType"                            
                            v-bind:renderindex="index"
                            v-bind:ctype="item.ComponentType"
                            v-bind:blockprops="item.BlockProps">

                </component>
             
        </div>


    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import SharedComponents from '/src/components/ContentCreator/BlockComponentsList.js';
    import { computed, ref, toRef, nextTick } from 'vue'
    import { useEditorStore } from '/src/stores/EditorStore';
    import { toast } from 'vue3-toastify';
    import axios from '/src/components/NovaAxios.js';
    import Swal from 'sweetalert2'
      
    export default {
        name: 'LivePageRoot',
        
        props: {            
            selectedpage: '',
            msg: String
        },
        components: {
            ...SharedComponents
        },
        watch: {           
            SelectedPage: {
                handler(newValue, oldValue) {                    
                    if (newValue) {
                        this.LoadPageBlockData(newValue, oldValue);
                    }
                },
                immediate: true
            }
        },
        data() {
            return {   
                BlockBrowserForIndex: 0,
                ShowBlockBrowser: false,
                LoadPageError: '',
                ShowPageBlocks: false,
                Loading: true,                
                Store: null,            
                AnimationInProgress: false,
            };
        },
        computed:
        {       
            SelectedPage() {
                return this.selectedpage;
            },
            PageExistsButEmpty() {
                var ebe = this.SelectedPage && !this.LoadPageError && !this.Loading && this.ShowPageBlocks && this.ContentNodeCount < 1;
                return ebe;
            },
            ShowError() {
                var show = this.LoadPageError && !this.Loading && !this.ShowPageBlocks;
                return show;
            },
            ContentNodeCount()
            {
                return this.Store.CurrentPageBlockNodes.length;
            },
        },
        methods:
        {         
            PageLoading: function (val) {
                this.Loading = val;
            },
            LoadPageBlockData: async function (slug, previousSlug) {
                EventHub.$emit("PageLoading", true);
                this.LoadPageError = '';
                this.ShowPageBlocks = false;
                var that = this;
                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;

                axios.postForm(`/API/GetPageBlockDataLive?slug=${slug}`, { slug: slug }, {
                    cache: {
                        ttl: 5 * 60 * 1000 // 5 minutes.
                    },
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {
                    EventHub.$emit("PageLoading", false);
                    if (response.data.success) {
                        that.ShowPageBlocks = true;
                        that.Store.replaceCurrentBlockNodes(response.data.blockData);
                        that.Store.updateTenantConfig(response.data.tenantConfig);
                    }
                    else {
                        that.LoadPageError = response.data.msg;
                        toast.error("Error loading! " + response.data.msg);
                    }
                }).catch(function (error) {
                    debugger
                    EventHub.$emit("PageLoading", false);
                    that.LoadPageError = "There was an error loading the page data. Please refresh and try again.";
                    toast.error("There was an error. Please refresh the page and try again.");
                });
                
            },
        },
        created() {
            this.Store = useEditorStore();
            EventHub.$on('PageLoading', this.PageLoading);       
        },
        beforeUnmount() {
            EventHub.$off('PageLoading', this.PageLoading);       
        },
        mounted() {
            
        }
    }

 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    body {
        overflow: scroll; /* or overflow: auto; */
    }

    .colors .item:nth-child(8n+1) {
        margin-left: 10px !important;
    }

    .filepond--wrapper{
        width:unset !important;
    }
    .filepond--credits{
        display:none;
    }

    .nova-blur {
        filter: blur(4px);
    }
    .nova-block-list-item {
        transition: all 0.3s ease;
    }

    .nova-block-list-enter-from,
    .nova-block-list-leave-to {
        opacity: 0;
      /*  transform: translateX(30px);     */
    }

    .nova-block-list-leave-active 
    {
       /* position: absolute;*/
    }

    .nova-block-list-move {
        transition: transform 0.8s ease;
    }

    .tox .tox-dialog--width-lg{
        max-height: 500px !important;
        max-width: calc(100hw * 0.7) !important
    }
</style>
